
import './App.css';
import Footer from './Footer/footer';
import Navbar from './Navbar/navbar';
import Routerss from './Routerss';

function App() {
  return (
    <div className="App">
   <Navbar/>
   <Routerss/>
   <Footer/>
    </div>
  );
}

export default App;
